import { Fragment, useState } from 'react';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import Loader from '../../../../common/Loader';

const initialValues = {
  emailAddress: ""
}

const objErrorValues = {
  isShow: false,
  isError: false,
  message: "",
}

var base_url = window.origin + '/classic/';
const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

export function ForgotPassword() {
  const [forgotValues, setForgotValues] = useState<any | ''>(initialValues);
  const [errorValues, setErrorValues] = useState<any | ''>(objErrorValues);
  const [isLoading, setIsLoading] = useState(false);

  const forgotPassword = async (value: any) => {
    if (NODE_ENV === "development") {
      base_url = REACT_APP_TIMELIVE_API_URL as string;
    }
    setIsLoading(true);
    setErrorValues({
      ...errorValues,
      isShow: false,
      isError: false,
      message: ""
    });
    try {
      // `https://localdebug2.livetecs.com/api/Account/ForgotPassword/`
      const response: any = await fetch(`${base_url}api/Account/ForgotPassword/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // "https://localdebug2.livetecs.com/beta/auth/resetpassword"
        body: JSON.stringify({ "EmailAddress": value.emailAddress, "Link": `${window.origin}/auth/resetpassword` })
      });
      const json = await response.json();
      if (json.StatusCode === "200") {
        setErrorValues({
          ...errorValues,
          isShow: true,
          isError: false,
          message: json.message
        });
      } else if (json.StatusCode === "404") {
        setErrorValues({
          ...errorValues,
          isShow: true,
          isError: true,
          message: json.message
        });
      } else {
        setErrorValues({
          ...errorValues,
          isShow: true,
          isError: true,
          message: json.message
        });
      }
    } catch {

    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="d-flex flex-column flex-root" style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh',
        width: '100%',
        position: 'relative'
        //backgroundColor: '#f2f6f8'
      }}>
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div className="d-flex flex-lg-row-fluid">
            <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
              <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
              <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                Fast, Efficient and Productive
              </h1>
              <div className="color-TextDarkBlue fs-base text-center fw-semibold">
                Discover the ultimate time tracking software designed to streamline your business operations.
                <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
              </div>
            </div>
          </div>
          <Formik
            initialValues={forgotValues}
            enableReinitialize={true}
            onSubmit={values => { forgotPassword(values) }}
            validationSchema={yup.object().shape({
              // emailAddress: yup
              //   .string()
              //   .label('Email Address')
              //   .required()
              //   .email('Invalid email address')
              emailAddress: yup
                            .string()
                            .label('Email Address')
                            .required()
                            .test(
                              'is-valid-email',
                              'Invalid email address',
                              value =>
                                value
                                  ? /^[a-zA-Z0-9._%+&()\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
                                  : false
                            )
            })}
          >
            {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
              <Fragment>
                <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                  <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow">
                    <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-425px" >
                      <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                        <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                          <div className="text-center mb-10">
                            <img
                              alt='Logo'
                              src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                              className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                            />
                            <h3 className="card-title fw-bold signTitle">
                              Forgot your password?
                            </h3>
                            <div className="text-gray-500 fs-6">
                              Enter your registered email. We will send a link to reset your password on your email address.
                            </div>
                          </div>
                          {errorValues.isShow &&
                            <div id="validationerror" className={errorValues.isError ? "alert alert-danger" : "alert alert-success"}>
                              <strong>{errorValues.isError ? "Error!" : "Success"}</strong>
                              <ul>
                                <li>{errorValues.message}</li>
                              </ul>
                            </div>
                          }
                          <div className="fv-row mb-8 fv-plugins-icon-container">
                            <input
                              type="text"
                              placeholder="Email"
                              name="email"
                              value={values.emailAddress}
                              onChange={handleChange('emailAddress')}
                              className='form-control fs-6 fw-normal'
                            />
                            <div>
                              {touched.emailAddress && errors.emailAddress &&
                                <p className='errorMsg'>{errors.emailAddress as string}</p>
                              }
                            </div>
                          </div>
                          <div className="d-grid mb-4">
                            <button
                              type="button"
                              className="btn btn-primary btn-bs-btn-font-weight me-2 fs-6"
                              onClick={() => handleSubmit()}
                              disabled={!isValid}
                            >
                              {('Send Email')}
                            </button>
                          </div>
                          <div className="text-gray-500 text-center fs-6">
                            Just Remembered.
                            <Link to='/auth/login'>
                              <a href="/metronic8/demo1/authentication/layouts/overlay/sign-up.html" className="text-primaryTL cursor ms-1">
                                Back to Sign in
                              </a>
                            </Link>{' '}
                          </div>
                        </div>
                      </div>
                      <div className=" d-flex flex-stack">
                        <div className="text-gray-500 text-center fs-6 mt-8">
                          By clicking Sign In button, I agree to Livetecs
                          <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Terms Of Use')}
                          </a> and <a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                            {('Privacy Policy')}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </Formik>
        </div>
      </div>
    </>
  )
}